const reloadFallbackKey = "river:chunk-reload"

const errorText = (error) =>
  [
    error?.name,
    error?.message,
    error?.type,
    error?.request,
    error?.filename,
    error?.target?.src,
    error?.target?.href,
  ]
    .filter(Boolean)
    .join(" ")

const isBuildAsset = (event) => {
  const target = event?.target
  const url = target?.src || target?.href || event?.filename || event?.request || ""

  return !url || url.includes("/wp-content/themes/river/build/") || url.includes("/build/")
}

const isChunkLoadError = (error) => {
  const text = errorText(error)

  return (
    /ChunkLoadError/i.test(text) ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(text) ||
    /o\[e\]\.call is undefined/i.test(text) ||
    /Cannot read propert(?:y|ies) of undefined \(reading ['"]call['"]\)/i.test(text)
  )
}

const reloadOnce = () => {
  const buildId = window.appjs?.assetVersion || window.river?.assetVersion || "unknown"
  const key = `${reloadFallbackKey}:${buildId}`

  try {
    if (window.sessionStorage.getItem(key)) {
      return
    }

    window.sessionStorage.setItem(key, `${Date.now()}`)
  } catch (error) {
    if (window.__riverChunkReloaded) {
      return
    }

    window.__riverChunkReloaded = true
  }

  window.setTimeout(() => {
    window.location.reload()
  }, 100)
}

window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason) && isBuildAsset(event.reason)) {
    reloadOnce()
  }
})

window.addEventListener(
  "error",
  (event) => {
    const target = event.target
    const isAssetLoadError = target && (target.tagName === "SCRIPT" || target.tagName === "LINK")

    if ((isAssetLoadError && isBuildAsset(event)) || (isChunkLoadError(event.error || event) && isBuildAsset(event))) {
      reloadOnce()
    }
  },
  true,
)
